import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const cddrcp4560 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_CoolingDegreeDays/MapServer/7",
    title: 'Cooling Degree Days Change until 2060',
    opacity: 0.4,
    oraId: 'cddrcp4560',
  })